<template>
  <div>
    <div class="row py-3">
      <div class="col-lg-5 col-sm-12 px-1">
        <div class="row">
          <div class="col-lg-12 pb-2 d-none d-lg-block">
            <action-items-dashboard></action-items-dashboard>
          </div>
          <div class="col-lg-12 mb-1">
            <businesses-dashboard @refresh="key++"></businesses-dashboard>
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-sm-12 px-1">
        <div class="row">
          <div class="col-12">
            <pending-payment-dashboard :key="key"></pending-payment-dashboard>
          </div>
          <div class="col-12 mt-1">
            <upcoming-invoices-dashboard></upcoming-invoices-dashboard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionItemsDashboard from './components/ActionItemsDashboard.vue';
import UpcomingInvoicesDashboard from './components/UpcomingInvoicesDashboard.vue';

export default {
  components: { ActionItemsDashboard, UpcomingInvoicesDashboard },
  props: {
  },
  mounted() {

  },
  data() {
    return {
      key: 1,
    };
  },
  methods: {

  },
};
</script>
